import React from "react";
import "../Crystals/Crystals.css";
import AboutSection from "../TopHeader/topheader";

const PoojasCard = () => {
  // 🔸 Add your product data here only
  const poojas = [
    {
      id: 1,
      name: "Raw Pyrite Bracelet (Women - 6mm Beads)",
      image:
        "/assets/carrerreportlogo.png",
      price: 699,
      originalPrice: 1999,
      rating: 4.82,
    },
    {
      id: 2,
      name: "Rose Quartz Bracelet (Love & Calm)",
      image:
        "/assets/carrerreportlogo.png",
      price: 599,
      originalPrice: 1799,
      rating: 4.9,
    },
    {
      id: 2,
      name: "Rose Quartz Bracelet (Love & Calm)",
      image:
        "/assets/carrerreportlogo.png",
      price: 599,
      originalPrice: 1799,
      rating: 4.9,
    },
    {
      id: 2,
      name: "Rose Quartz Bracelet (Love & Calm)",
      image:
        "/assets/carrerreportlogo.png",
      price: 599,
      originalPrice: 1799,
      rating: 4.9,
    },
    {
      id: 2,
      name: "Rose Quartz Bracelet (Love & Calm)",
      image:
        "/assets/carrerreportlogo.png",
      price: 599,
      originalPrice: 1799,
      rating: 4.9,
    },
    {
      id: 2,
      name: "Rose Quartz Bracelet (Love & Calm)",
      image:
        "/assets/carrerreportlogo.png",
      price: 599,
      originalPrice: 1799,
      rating: 4.9,
    },
   
  
  ];

  return (
    <div className="crystals-mian-contaier">
     <AboutSection 
  title="POOJAS"
  description="But your desired crystals from cosmical calculators 100% original gems ,stones and crystals according to you kundli."
/>
    <div className="product-container">

      {poojas.map((item) => (
        <div className="product-card" key={item.id}>
          <div className="product-img-wrapper">
            <img src={item.image} alt={item.name} className="product-img" />
            <div className="rating-badge">
              ⭐ <span>{item.rating}</span>
            </div>
          </div>

          <div className="product-info">
            <h3 className="product-name">{item.name}</h3>

            <div className="product-pricing">
              <span className="price">₹{item.price.toLocaleString("en-IN")}</span>
              <span className="original-price">
                ₹{item.originalPrice.toLocaleString("en-IN")}
              </span>
            </div>

            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeSezCKKbsmvDM6plRPdw4GfWAw03I_MVEuJPDGQvImYsIu8g/viewform"><button className="add-cart-btn">ADD TO CART</button></a>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default PoojasCard;
